const Mission = () => {
    return (
        <main className='main-container'>
            <div className="main-wrapper">
                <section className="review-area pb-100 pt-40" id="mission">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <br />
                                <header className="pt-120">
                                    <h1 className="page-heading">Mission</h1>
                                </header>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <article className="col-lg-6 video-left">
                                <p>
                                    Our mission is to provide robust, Bible-centered education that strengthens believers in their understanding of Christian doctrines and fosters a vibrant devotional life, preparing them to engage the world with confidence, clarity, and Chirst-like character, and to actively support ministries in remote places and churches through missions that spread the love and truth of Jesus Christ.
                                </p>
                            </article>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
}
export default Mission;